import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axiosConfig';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userData, setUserData] = useState({});
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  const checkAuthStatus = async () => {
    try {
      const res = await API.get('/api/me/'); 
      const user = res.data;
      
      const cleanUserObj = {
        ...user,
        role: user?.role ? user.role.toUpperCase() : 'STUDENT',
        is_staff: user?.is_staff || user?.is_superuser || false
      };
      
      setUserData(cleanUserObj);
      setUsername(cleanUserObj.username);
      setToken("session_active_via_cookies");
      localStorage.setItem('user_data', JSON.stringify(cleanUserObj));
      localStorage.setItem('username', cleanUserObj.username);
    } catch (e) {
      console.warn("[AuthContext] API /api/me/ недоступно, но мы НЕ делаем логаут. Оставляем сессию живой.");
      // МЫ УДАЛИЛИ ВЫЗОВ logout() ОТСЮДА!
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedUserData = localStorage.getItem('user_data');
    const savedUsername = localStorage.getItem('username');

    if (savedUserData) {
      try {
        const parsedData = JSON.parse(savedUserData);
        setUserData(parsedData);
        setToken("session_active_via_cookies");
        setUsername(savedUsername || parsedData.username);
        
        checkAuthStatus();
      } catch (e) {
        console.error("[AuthContext] Ошибка парсинга:", e);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const login = (userObj, name) => {
    const cleanUserObj = {
      ...userObj,
      role: userObj?.role ? userObj.role.toUpperCase() : 'STUDENT',
      is_staff: userObj?.is_staff || userObj?.is_superuser || false
    };

    const finalName = name || userObj?.username || 'Пользователь';

    localStorage.setItem('user_data', JSON.stringify(cleanUserObj));
    localStorage.setItem('username', finalName);

    setToken("session_active_via_cookies"); 
    setUserData(cleanUserObj);
    setUsername(finalName);
  };

  const logout = () => {
    localStorage.removeItem('user_data');
    localStorage.removeItem('username');
    setToken(null);
    setUserData({});
    setUsername('');
  };

  const updateUserData = (updatedFields) => {
    setUserData((prevData) => {
      const newData = { ...prevData, ...updatedFields };
      if (newData.role) newData.role = newData.role.toUpperCase();
      localStorage.setItem('user_data', JSON.stringify(newData));
      return newData;
    });
  };

  return (
    <AuthContext.Provider value={{ 
      token, 
      isAuthenticated: !!token, 
      userData, 
      username, 
      login, 
      logout, 
      updateUserData, 
      loading,
      isAdmin: userData?.role === 'ADMIN' || userData?.is_staff,
      isTeacher: userData?.role === 'TEACHER',
      isStudent: userData?.role === 'STUDENT'
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);